<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-06-01 20:15:59
 * @LastEditors: 诺
 * @LastEditTime: 2022-06-01 20:53:06
-->
<template>
  <div class="main">
    <div class="complaint" @click="mask_box = true">
      <img
        src="https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/icon-attention.png"
      />
      投诉
    </div>
    <div class="mask_box" v-if="mask_box">
      <div class="complaint-container">
        <div class="complaint-title">投诉原因</div>
        <div class="complaint-box">
          <div v-for="(item, index) in complaint" :key="index" @click="tapComplaint(index)">{{ item }}</div>
        </div>
        <div class="complaint-cancel" @click="mask_box = false">取消</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
export default {
  props: {},
  watch: {},
  data() {
    return {
      mask_box: false,
      complaint: [
        "传播不实信息",
        "包含侵权或违法信息",
        "包含诱导分享/关注的内容",
        "过度骚扰",
        "包含谣言信息",
        "其他",
      ],
    };
  },
  methods: {
    async tapComplaint(index){
      await this.$httpdf.get(this.apiHost + 'info/click', { sceneKey: 1000 + index })
      Toast({
        message: '我们将核实反馈信息 尽快处理您的投诉!',
      })
      this.mask_box = false
    }
  }
};
</script>
<style lang="scss" scoped>
.complaint {
  position: fixed;
  z-index: 101;
  bottom: 12px;
  right: 22px;
  background: rgba(255, 255, 255, 0.15);
  opacity: 0.7;
  border-radius: 20px;
  width: 56px;
  height: 20px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
.mask_box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .complaint-container {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #f8f8fb;
    .complaint-title {
      background: #fff;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 20px;
      color: #000;
      font-weight: 700;
      border-bottom: 1px solid #eef0f3;
    }
    .complaint-box {
      div {
        background: #fff;
        height: 40px;
        line-height: 40px;
        padding: 0 30px;
        font-size: 14px;
        color: #262626;
        border-bottom: 1px solid #eef0f3;
      }
    }
    .complaint-cancel {
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #617086;
      text-align: center;
      padding-bottom: 10px;
      background: #fff;
    }
  }
}
</style>
